<template>
  <form v-else @submit.prevent="crearProducto">
    <vuestic-widget header-text="Creación de Producto">
      <DescripcionProducto/>
    </vuestic-widget>
    <vuestic-widget header-text="Detalle Producto Para Web" v-if="isWeb()">
      <DetalleWeb/>
    </vuestic-widget>
    <vuestic-widget header-text="Detalle">
      <DetalleProducto/>
    </vuestic-widget>
    <vuestic-widget header-text="Vehiculos Compatibles">
      <VehiculosCompatible/>
      <hr>
      <button class="btn btn-success btn-micro" type="submit">Crear Producto</button>
    </vuestic-widget>
  </form>
</template>

<script>
  import VuesticWidget from "../../../../../vuestic-theme/vuestic-components/vuestic-widget/VuesticWidget";
  import DescripcionProducto from "../descripcionProducto/DescripcionProducto";
  import DetalleProducto from "../detalleProducto/DetalleProducto";
  import VehiculosCompatible from "../vehiculoCompatible/VehiculosCompatible";
  import DetalleWeb from "../descripcionWeb/DetalleWeb";
  import mixinProducto from "../mixins/mixinProducto";

  export default {
    name: "CreacionFormulario",
    components: {DetalleWeb, VehiculosCompatible, DetalleProducto, DescripcionProducto, VuesticWidget},
    mixins: [mixinProducto],
    methods: {
      crearProducto() {
        this.$store.dispatch("producto/crearProducto", {method: "POST"})
          .then(response => {
            if (response.status === 201) this.successResponse("Producto Creado Correctamente!!")
            else this.errorResponse()
          }).catch(error => {
          console.error(error, "failed to create producto")
          this.$swal("Error!", error, "error")
        })
      },
      successResponse(message) {
        this.$swal("Correcto!", message, "success")
        this.$router.push("listar-producto-miranda")
        this.$store.commit("producto/RESET_STATE")
      },
      errorResponse(response) {
        console.log(response.data)
        this.$swal("Error", "error", "error")
      }
    }
  }
</script>

<style scoped>

</style>
